import template from './store-finder.html';
import controller from './store-finder.controller';

let storeFinderComponent = {
    restrict: 'E',
    bindings: {branch:'='},
    template,
    controller
};

export default storeFinderComponent;


// WEBPACK FOOTER //
// ./src/app/common/storefinder/store-finder.component.js